import clsx from 'clsx';
import { FC, ReactNode, useEffect, useState } from 'react';
import type { DeviceAnimationProps } from './DeviceAnimation';
import BorderBeam from './BorderBeam';

interface LoadingWrapperProps extends DeviceAnimationProps {
  children: ReactNode;
  loading: boolean;
  show: boolean;
}

const LoadingWrapper: FC<LoadingWrapperProps> = ({
  children,
  show,
  loading,
  ...rest
}) => {
  const [removeFromDOM, setRemoveFromDOM] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (!loading) {
      timeoutId = setTimeout(() => {
        setRemoveFromDOM(true);
      }, 900);
    } else {
      setRemoveFromDOM(false);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [loading]);

  if (!show) return children;

  return (
    <div className="relative">
      <div
        className={clsx('absolute inset-0 duration-700 ', {
          'h-[617px] opacity-100 ': loading,
          'h-0 opacity-0': !loading,
        })}
      >
        {!removeFromDOM && <BorderBeam {...rest} />}
      </div>
      <div
        className={clsx('duration-700', {
          'opacity-0': loading,
          'opacity-100': !loading,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default LoadingWrapper;
